import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedRouteCard = ({ route, onRemove }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card border border-border rounded-xl p-4 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Bookmark" size={20} className="text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm md:text-base font-semibold text-foreground truncate">
              {route?.from} → {route?.to}
            </h4>
            <p className="text-xs text-muted-foreground">
              {route?.distance} • {route?.duration}
            </p>
          </div>
        </div>
        <button
          onClick={() => onRemove(route?.id)}
          className="p-2 rounded-lg hover:bg-destructive/10 text-muted-foreground hover:text-destructive transition-colors flex-shrink-0"
          aria-label="Remove saved route"
        >
          <Icon name="Trash2" size={16} />
        </button>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-lg font-bold text-foreground whitespace-nowrap">
          ₹{route?.estimatedFare?.toLocaleString('en-IN')}
        </p>
        <Button
          variant="default"
          size="sm"
          iconName="Calendar"
          iconPosition="left"
          onClick={() => navigate('/booking-confirmation')}
        >
          Book Now
        </Button>
      </div>
    </div>
  );
};

export default SavedRouteCard;